// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullRegattaGroup,
} from 'common.data';

// Global Components
import * as React from 'react';

// Helpers
import _ from 'lodash';
import {
  getImageUrl,
} from '@vroskus/library-helpers/dist/browser';
import {
  getRegattaGroupName,
} from '../../../helpers';
import config from '../../../config';

// Components
import InputLabel from '../InputLabel';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  label?: string;
  labelClassName?: string;
  onChange?: (value: string) => unknown;
  required?: boolean;
  value?: null | string;
};

type $Props = $InputProps & $OptionalProps & $Translate & {
  highlight: boolean;
  items: Array<$FullRegattaGroup>;
  name: string;
};

class InputRegattaGroupView extends React.Component<$Props> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    label: undefined,
    labelClassName: undefined,
    onChange: undefined,
    required: undefined,
    value: undefined,
  };

  renderItem(item: $FullRegattaGroup) {
    const {
      name,
      onChange,
      required,
      setValue,
      t,
      value,
    } = this.props;

    const groupName: string = getRegattaGroupName(item) || t('Ungrouped');

    return (
      <label
        className={`btn btn_light btn_outlined min-w-20 flex flex-col cursor-pointer rounded-2xl px-1 ${value === item.id ? 'btn_primary bg-blue-50' : ''}`}
        htmlFor={item.id}
        key={item.id}
      >
        <input
          checked={value === item.id}
          id={item.id}
          name={name}
          onChange={(e) => {
            setValue(e.currentTarget.value);

            if (onChange) {
              onChange(item.id);
            }
          }}
          required={required}
          style={{
            height: 0,
            opacity: 0,
            position: 'absolute',
            width: 0,
          }}
          type={'radio'}
          value={item.id}
        />
        <img
          alt={groupName}
          className={'mx-auto h-14'}
          src={getImageUrl({
            cdnUrl: config.CDN_URL,
            image: item.Group.Image,
            size: 'min',
          })}
        />
        <p className={'uppercase text-gray-400 text-center text-xs p-1'}>
          {groupName}
        </p>
      </label>
    );
  }

  render() {
    const {
      className,
      highlight,
      isValid,
      items,
      label,
      labelClassName,
      name,
      required,
    } = this.props;

    const sortedGroups = _.sortBy(
      items,
      'Group.Name',
    );

    return (
      <div className={`InputRegattaGroup ${className || ''}`}>
        <InputLabel
          className={labelClassName}
          label={label}
          name={name}
          required={required}
        />
        <div className={`border-${highlight && !isValid ? 'red-600' : 'gray-400'} flex flex-row space-x-4 p-2 rounded-lg border w-full focus:outline-none focus:border-blue-400 overflow-x-auto`}>
          {sortedGroups.map((item: $FullRegattaGroup) => this.renderItem(item))}
        </div>
      </div>
    );
  }
}

export default InputRegattaGroupView;
